import {useEffect, useState} from "react";
import Navbar from "../Components/Navbar";
import ContactFooter from "../Components/ContactFooter";
import Popup from "../Components/PopUp";
import AddMenuItemBody from "./PopUpBodies/AddMenuItemBody";
import EditMenuItemBody from "./PopUpBodies/EditMenuItemBody";
import {AiOutlinePlusSquare, AiOutlineEdit} from "react-icons/ai";
import {Dish} from "../Types/Dish";
import {getAllMenuItems} from "../Services/MenuItemService";

export function MenuItem() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<"add" | "edit">("add");
  const [selectedDish, setSelectedDish] = useState<Dish | null>(null);

  const openAddPopup = () => {
    setModalMode("add");
    setSelectedDish(null);
    setIsModalOpen(true);
  };

  const openEditPopup = (dish: Dish) => {
    setModalMode("edit");
    setSelectedDish(dish);
    setIsModalOpen(true);
  };

  const closePopup = () => {
    setSelectedDish(null);
    setIsModalOpen(false);
  };

  const [dishes, setDishes] = useState<Dish[]>([]);

  const loadDishes = async () => {
    try {
      const data = await getAllMenuItems();
      setDishes(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadDishes();
  }, []);

  return (
    <>
      <Navbar/>

      <div className="white-text-block white-text-block--header">
        <h1 className="header-1 header-1--centered">Gerechten</h1>
        
        <button type="button" onClick={openAddPopup}>
          <AiOutlinePlusSquare size={50}/>
        </button>
      </div>
      
      <div className="shop-items-grid">
        {dishes.map((dish) => (
          <div key={dish.name} className="shop-item">
            <img className="picture-container" 
                 src={`${process.env.REACT_APP_API_URL}${dish.picturePath}`} 
                 alt="Image not found"/>
            
            <div className="shop-item-data">
              <h3 className="header-2">{dish.name}</h3>
              <p>{dish.description}</p>
              <hr className="shop-item-divider"/>
              <p>€{dish.price}</p>
            </div>
            
            <div className="align-button-right">
              <button type="button"
                      onClick={() => openEditPopup(dish)}
                      className="shop-item-button">
                <AiOutlineEdit size={35}/>
              </button>
            </div>
          </div>
        ))}
      </div>

      <Popup isOpen={isModalOpen} onClose={closePopup}>
        {modalMode === "add" ? <AddMenuItemBody onSaved={() => {
          loadDishes();
          closePopup();
        }}/> : selectedDish ? <EditMenuItemBody dish={selectedDish} onSaved={() => {
          loadDishes();
          closePopup();
        }}/> : null}
      </Popup>

      <ContactFooter/>
    </>
  );
}

export default MenuItem;